import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _Reply;
import { Fragment, useEffect, useState } from 'react';
import Reply from '@crehana/icons/Reply';
import { Drawer } from '@crehana/ui';
import { VIDEO_SPEEDS } from "../../../constants";
import { useHlsContext } from "../../../context/Hls";
import { usePlaybackContext } from "../../../context/Playback";
import { useSubtitleContext } from "../../../context/Subtitle";
import { useUIContext } from "../../../context/UI";
import { useTranslation } from "../../../hooks";
import OptionButton from "./OptionButton";
import Submenu from "./Submenu";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MobileSheet = function MobileSheet(_ref) {
  var onDismiss = _ref.onDismiss,
    onSpeedChange = _ref.onSpeedChange,
    onQualityChange = _ref.onQualityChange,
    onSubtitlesChange = _ref.onSubtitlesChange,
    onAudioChange = _ref.onAudioChange;
  var _usePlaybackContext = usePlaybackContext(),
    currentSpeed = _usePlaybackContext.currentSpeed;
  var _useHlsContext = useHlsContext(),
    qualities = _useHlsContext.qualities,
    currentQuality = _useHlsContext.currentQuality,
    currentQualityLabel = _useHlsContext.currentQualityLabel,
    hasLowQuality = _useHlsContext.hasLowQuality,
    audios = _useHlsContext.audios,
    currentAudio = _useHlsContext.currentAudio;
  var _useSubtitleContext = useSubtitleContext(),
    subtitleOptions = _useSubtitleContext.subtitleOptions,
    currentSubtitleLang = _useSubtitleContext.currentSubtitleLang;
  var _useUIContext = useUIContext(),
    activeMenu = _useUIContext.activeMenu,
    hideSpeedOptions = _useUIContext.hideSpeedOptions;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(!!activeMenu),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(activeMenu || 'settings'),
    _useState4 = _slicedToArray(_useState3, 2),
    current = _useState4[0],
    setCurrent = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    section = _useState6[0],
    setSection = _useState6[1];
  var onBack = function onBack() {
    setSection(undefined);
  };
  useEffect(function () {
    setOpen(!!activeMenu);
    if (activeMenu) {
      setCurrent(activeMenu);
    }
  }, [activeMenu]);
  useEffect(function () {
    if (open) {
      onBack();
    }
  }, [open]);
  var changeSection = function changeSection(newSection) {
    switch (newSection) {
      case 'speed':
        setSection({
          title: t('SPEED'),
          options: VIDEO_SPEEDS,
          selectedValue: currentSpeed.value,
          onSelect: onSpeedChange
        });
        break;
      case 'quality':
        setSection({
          title: t('QUALITY'),
          options: qualities,
          selectedValue: currentQuality === null || currentQuality === void 0 ? void 0 : currentQuality.value,
          onSelect: onQualityChange
        });
        break;
      case 'subtitles':
        setSection({
          title: t('SUBTITLES'),
          options: subtitleOptions,
          selectedValue: currentSubtitleLang === null || currentSubtitleLang === void 0 ? void 0 : currentSubtitleLang.value,
          onSelect: onSubtitlesChange
        });
        break;
      case 'audio':
        setSection({
          title: t('AUDIO'),
          options: audios,
          selectedValue: currentAudio === null || currentAudio === void 0 ? void 0 : currentAudio.value,
          onSelect: onAudioChange
        });
        break;
      default:
    }
  };
  return /*#__PURE__*/_jsx(Drawer, {
    position: "bottom",
    className: "px-16",
    open: open,
    onDismiss: onDismiss,
    disabledFocusLock: true,
    "data-testid": "cp-menu-mobile-sheet",
    children: section ? /*#__PURE__*/_jsx(Submenu, _objectSpread(_objectSpread({}, section), {}, {
      onBack: onBack
    })) : /*#__PURE__*/_jsxs(Fragment, {
      children: [current === 'cc' ? /*#__PURE__*/_jsxs(Fragment, {
        children: [subtitleOptions && /*#__PURE__*/_jsx(OptionButton, {
          label: t('SUBTITLES'),
          value: currentSubtitleLang === null || currentSubtitleLang === void 0 ? void 0 : currentSubtitleLang.label,
          id: "subtitles",
          changeSection: changeSection
        }), audios && audios.length > 1 && /*#__PURE__*/_jsx(OptionButton, {
          label: t('AUDIO'),
          value: currentAudio === null || currentAudio === void 0 ? void 0 : currentAudio.label,
          id: "audio",
          changeSection: changeSection
        })]
      }) : /*#__PURE__*/_jsxs(Fragment, {
        children: [qualities && /*#__PURE__*/_jsx(OptionButton, {
          label: t('QUALITY'),
          value: currentQualityLabel,
          id: "quality",
          changeSection: changeSection,
          hasLowQuality: hasLowQuality
        }), !hideSpeedOptions && /*#__PURE__*/_jsx(OptionButton, {
          label: t('SPEED'),
          value: currentSpeed.label,
          id: "speed",
          changeSection: changeSection
        })]
      }), /*#__PURE__*/_jsxs("button", {
        type: "button",
        className: "bg-transparent text-base-main font-button focus:outline-none w-full flex items-center py-32",
        onClick: onDismiss,
        children: [_Reply || (_Reply = /*#__PURE__*/_jsx(Reply, {
          className: "fill-current min-w-24 mr-16",
          size: 24,
          ignoreColor: true
        })), t('BACK_TO_VIDEO')]
      })]
    })
  });
};
export default MobileSheet;